import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';

// Import the Image gallery css
import "react-image-gallery/styles/css/image-gallery.css";

class CaseStudyBox extends Component {
  transformBoxData(data) {
    // Figure out the slides
    const slides = [];
    if (data.acf && data.acf.slides) {
      data.acf.slides.forEach((slide) => {
        slides.push({
          original: slide.image,
          description: slide.description,
          thumbnail: slide.image,
        })
      })
    }

    return {
      title: data.title.rendered,
      content: data.content.rendered,
      slides,
    }
  }

  render() {
    
    const {
      data,
      history,
    } = this.props;
    // Transform the data first
    const boxData = this.transformBoxData(data);

    let content = null;
    if (boxData.slides.length > 0) {
      content = <ImageGallery
        items={boxData.slides}
        showIndex
        showNav
      />
    }

    return (
      <div className="post-wrapper">
      <div className="row casestudy-box">
          <div className="col-12">
            <button className="btn btn-orange back-button" onClick={() => history.goBack()}>
              Back
            </button>
            <h3 className="title text-center">{boxData.title}</h3>
            {content}
            <div className="aligncenter button" style={{marginTop: '4rem'}}>
              <a className="btn btn-orange" href={data.acf.file} target="_blank" rel="noopener noreferrer" download>
              DOWNLOAD RESOURCES
              </a>
            </div>
            <div><span>"The case study is intended for medical information/education purposes only. It is not intended to be used for medical diagnosis or treatment or as a substitute for professional medical advice. Individual symptoms, situations and circumstances may vary."</span></div>
          </div>
      </div>
      </div>
    )
  }
}

export default CaseStudyBox;
